import React from 'react';

const HeroSection = props => {
  return (
    <div style={{ height: props.height || '50vh' }}>
      <div className="hero-section-container">
        <div className="hero-image-container">
          <img src={props.heroImage} alt="hero-view" />
        </div>

        {props.title && (
          <div className="hero-overlap">
            <div className="punch-line">
              <div className="punch-line-container">
                <span className="font26 bold-text general-text white-text">
                  {props.t ? props.t(props.title) : props.title}
                </span>
              </div>

              {props.description && (
                <div className="baseline">
                  <span className="font14 general-text white-text">
                    {props.t ? props.t(props.description) : props.description}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroSection;



// WEBPACK FOOTER //
// ./src/features/pages/HeroSection/HeroSection.js